import { render } from "./CurrencyCircleDollarIcon.vue?vue&type=template&id=60691848"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__